// IFA channel copy for /ifa, transcribed from the approved mockup
// (docs/omw419/copy/IFA.txt). IFA has no cash incentive; its Terms and
// Conditions are the shared platform terms plus the Executor Fee Share
// section from legal's Figma copy (docs/omw419/copy/terms-and-conditions.md).
import { IFA_CHANNEL_COMPANY_IDS } from '@/constants/adviser-channel-companies';
import {
  EXECUTOR_FEE_SHARE_TERMS,
  PLATFORM_TERMS,
} from '@/constants/adviser-enrolment/platform-terms';

export const IFA_CHANNEL = {
  key: 'ifa',
  heroSection: 'adviserIfaHeader',
  companyIds: IFA_CHANNEL_COMPANY_IDS,
  intro: {
    heading: 'Why Wills matter',
    lead: '85%<sup>1</sup> of South Africans die without a will, leaving their families vulnerable when the unexpected happens. As trusted financial advisers, you have the power to change this.',
    paragraphs: [
      "Through the <strong>Old Mutual Will platform</strong>, we're making it easier than ever to help clients <strong>protect their legacy and provide for their loved ones</strong>.",
    ],
    footnote: "1. According to Master's Office 2022",
  },
  earnings: {
    heading: 'Grow your practice with will services',
    intro: 'Old Mutual Will gives you:',
    bullets: [
      'A fresh way to add value to every client relationship',
      'A simple way to open estate planning conversations',
      'The support of a dedicated team, every step of the way',
    ],
    outro:
      'Simply register as an adviser on the platform to get started.<br />View <a href="#terms">Terms and conditions</a>',
  },
  incentives: {
    heading: 'Incentives',
    lead: 'Every Will completed through the Old Mutual Will platform includes the appointment of Old Mutual Will as executor.',
    body: "Participating advisers qualify for a share of the executor's fee, earning up to 20% on estates between R1 million and R5 million and up to 25% on estates above R5 million. The applicable channel agreement sets the fee payable for the specific channel.",
  },
  resources: {
    heading: 'Resources',
    subtitle:
      'Below are a number of resources that outlines the opportunity, and supports you to get you started on the platform.',
  },
  brochures: [
    {
      icon: 'document',
      title: 'OM Will Adviser One Pager',
      description:
        'All the key facts about the Old Mutual Will proposition that you as an adviser may need.',
      buttonText: 'Download',
      download: 'IFA_Adviser_OnePager_26_V1.pdf',
    },
    {
      icon: 'document',
      title: 'OM Will and OMP Overview',
      description:
        'An overview of how OM Will informs financial planning conversations with clients and enables OMP sales.',
      buttonText: 'Download',
      download: 'IFA_Adviser_OMWill_OMP_Overview_26_V2.pdf',
    },
    {
      icon: 'document',
      title: 'OM Will and OMP - How it works',
      description:
        'A description of how the OM Will platform enables you to capture the OMP sale.',
      buttonText: 'Download',
      download: 'IFA_Adviser_OMWill_OMP_HowTo_26_V1.pdf',
    },
  ],
  terms: {
    ...PLATFORM_TERMS,
    sections: [EXECUTOR_FEE_SHARE_TERMS],
  },
};
